import { IImageWorldMarker } from 'react-give-me-map';

export const VIEWPORT = {
    latitude: 63.429126,
    longitude: 10.406168,
    zoom: 13.83
};

export const COORDS: IOCoords[] = [
    {
        lat: 63.43550826585948,
        lng: 10.394237179657551,
        xPercent: 6.133466719561205,
        yPercent: 31.86680375922218,
        hiddenLat: 63.430867876076405,
        hiddenLng: 10.396319111087166
    },
    {
        lat: 63.422709924723335,
        lng: 10.39660339599314,
        xPercent: 12.502963932237924,
        yPercent: 96.08559882439383,
        hiddenLat: 63.4247005074283,
        hiddenLng: 10.397749119610069
    },
    {
        lat: 63.42808224680064,
        lng: 10.4033629296475,
        xPercent: 26.497139644853014,
        yPercent: 68.74394798727349,
        hiddenLat: 63.4273274297465,
        hiddenLng: 10.400890932258022
    },
    {
        lat: 63.4285291952919,
        lng: 10.422428139822728,
        xPercent: 67.48376017322482,
        yPercent: 65.56511689650326,
        hiddenLat: 63.427631581758504,
        hiddenLng: 10.41009344189834
    },
    {
        lat: 63.43721539708767,
        lng: 10.43063983874373,
        xPercent: 84.22037626818137,
        yPercent: 21.53624283212581,
        hiddenLat: 63.43186021409355,
        hiddenLng: 10.41385037549577
    },
    {
        lat: 63.44115452060561,
        lng: 10.418760824394155,
        xPercent: 58.27726921804346,
        yPercent: 2.3356401384083045,
        hiddenLat: 63.43370493294745,
        hiddenLng: 10.408025462803039
    }
];

export const FIXED_MARKER = {
    id: '1',
    lat: VIEWPORT.latitude,
    lng: VIEWPORT.longitude,
    scalable: true,
    scale: 0.0002554505239324302,
    visible: true,
    selectable: true,
    rotate: 0,
    order: 1,
    elementType: 'image',
    elementData: {
        src: 'https://dvtqxks0zalev.cloudfront.net/869206d6-d135-4b26-8007-31f923b69cef.jpeg',
        additionalSrc: {
            '100': 'https://dvtqxks0zalev.cloudfront.net/100/869206d6-d135-4b26-8007-31f923b69cef.jpeg',
            '600': 'https://dvtqxks0zalev.cloudfront.net/600/869206d6-d135-4b26-8007-31f923b69cef.jpeg',
            '1000': 'https://dvtqxks0zalev.cloudfront.net/1000/869206d6-d135-4b26-8007-31f923b69cef.jpeg',
            '1920': 'https://dvtqxks0zalev.cloudfront.net/1920/869206d6-d135-4b26-8007-31f923b69cef.jpeg',
            '4096': 'https://dvtqxks0zalev.cloudfront.net/869206d6-d135-4b26-8007-31f923b69cef.jpeg'
        },
        layerData: null
    }
} as IImageWorldMarker;

export interface IOCoords {
    lat: number;
    lng: number;
    xPercent: number;
    yPercent: number;
    hiddenLat?: number;
    hiddenLng?: number;
}
